import React from  "react";
import App from '../utils/app'
import * as keys from './apps/app_keys'

import ZoomControls from './apps/zoom_controls'
import PreviewMap from './apps/preview'
import AnnotationsApp from './apps/tagger/annotations_app'
import GridOverLay from './apps/grid_overlay'
import ScreenshotApp from './apps/screenshot'
import SettingsApp from './apps/settings'
import SlideInfoApp from './apps/slide_info'
import ReportApp from './apps/cap_report'
import CapGuideApp from './apps/cap_guide'
import IHCApp from './apps/tagger/ihc'
import PresentApp from './apps/present'

const appify = (key, content, allAppsState) => {
    return (
        allAppsState[key.id + "_installed"] === undefined || allAppsState[key.id + "_installed"] === true ? 
            <App
                key={key.id}
                appKey={key}
                startTop={((allAppsState.app_state[key.id] || {}).position || {y : key.defaultY}).y}
                startLeft={((allAppsState.app_state[key.id] || {}).position || {x : key.defaultX}).x}
                defaultClosed={(allAppsState.app_state[key.id] || {}).closed}
                content={content} /> : undefined
    )
}

const getZoomControlsApp = (slideState, allAppsState) => {
    return appify(keys.zoomAppKey, 
                <ZoomControls 
                    view={slideState.view}
                    zoomScale={slideState.zoomScale}
                    maxZoom={slideState.maxZoom} 
                    goHome={slideState.goHome} />, 
                    allAppsState
    )
}

const getAnnotationApp = (slideState, allAppsState) => {
    return appify(keys.annotationsAppKey, 
                <AnnotationsApp
                    id={keys.annotationsAppKey.id}
                    slide={slideState.slide_data}
                    slidemap={slideState.slidemap}
                    zoomScale={slideState.zoomScale} />, 
                    allAppsState
    )
}

const getPreviewApp = (slideState, allAppsState) => {
    return appify(keys.previewControlsKey, 
            <PreviewMap
                slidemap={slideState.slidemap}
                view={slideState.view}
                layers={[slideState.layer]}
                addPreviewMapControl={slideState.addPreviewMapControl}
                zoomScale={slideState.zoomScale}
                maxZoom={slideState.maxZoom}
                zoomLevels={slideState.zoomLevels} />, 
                allAppsState
    )
}

const getGridApp = (slideState, allAppsState) => {
    return appify(keys.gridOverlayAppKey, 
                <GridOverLay
                    id={keys.gridOverlayAppKey.id}
                    slidemap={slideState.slidemap} />, 
                    allAppsState
    )
}

const getScreenshotApp = (slideState, allAppsState) => {
    return appify(keys.screenshotAppKey, 
                <ScreenshotApp
                    slideName={slideState.slide_data.name}
                    case={slideState.slide_data.case} />, 
                    allAppsState
    )
}

const getSettingsApp = (slideState, allAppsState) => {
    return appify(keys.settingsAppKey, 
                <SettingsApp
                    slideData={slideState.slide_data}
                    mapId={slideState.mapId}
                    slidemap={slideState.slidemap} />, 
                    allAppsState
    )
}

const getSlideInfoApp = (slideState, allAppsState) => {
    return appify(keys.slideInfoAppKey, 
                <SlideInfoApp
                    slideData={slideState.slide_data}
                     />, 
                     allAppsState
    )
}

const getIHCApp = (slideState, allAppsState) => {
    return appify(keys.ihcAppKey, 
                <IHCApp
                    id={keys.ihcAppKey.id}
                    slide={slideState.slide_data}
                    slidemap={slideState.slidemap} 
                    zoomScale={slideState.zoomScale}
                     />, 
                     allAppsState
    )
}

const getReportApp = (slideState, allAppsState) => {
    return appify(keys.reportAppKey, 
                <ReportApp
                    slideData={slideState.slide_data}
                     />, 
                allAppsState
    )
}

const getCapGuideApp = (slideState, allAppsState) => {
    return appify(keys.capGuideAppKey, 
                <CapGuideApp
                    slideData={slideState.slide_data}
                     />, 
                allAppsState
    )
}

const getPresentApp = (slideState, allAppsState) => {
    return appify(keys.presentAppKey, 
        <PresentApp
            id={keys.presentAppKey.id}
            slideData={slideState.slide_data}
            view={slideState.view} />, 
            allAppsState
    )
}

export const getAllApps = (slideState, allAppsState) => {
    return [
        getZoomControlsApp(slideState, allAppsState), 
        getPreviewApp(slideState, allAppsState),
        getSlideInfoApp(slideState, allAppsState),
        getAnnotationApp(slideState, allAppsState), 
        getGridApp(slideState, allAppsState), 
        getScreenshotApp(slideState, allAppsState), 
        getSettingsApp(slideState, allAppsState), 
        getReportApp(slideState, allAppsState),
        getCapGuideApp(slideState, allAppsState), 
        getIHCApp(slideState, allAppsState), 
        getPresentApp(slideState, allAppsState)
    ]
}